// extracted by mini-css-extract-plugin
export default {"docs":"knqPk","docs-items":"NlWyN"};